import { defineMessages } from 'react-intl';

export const messages: {
	addPeopleButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionWithoutPageTitleGeneric: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionWithoutPageTitleGenericIssueTermRefresh: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionWithPageTitleGeneric: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dismiss: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleGeneric: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	addPeopleButton: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.add-people-button',
		defaultMessage: '{inviteeCount, plural, one {Add {firstName}} other {Add # people}}',
		description: 'CTA on a primary button to invite a group of people',
	},
	dismiss: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.dismiss',
		defaultMessage: "Don't show again",
		description: 'Secondary button to dismiss the flag permanently',
	},
	titleGeneric: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.title-generic',
		defaultMessage:
			'{inviteeCount, plural, one {{displayName} may need access} other {Your team may need access}}',
		description: 'Title of a flag pop up where the user can invite one or more users.',
	},
	descriptionWithoutPageTitleGeneric: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic',
		defaultMessage:
			'{inviteeCount, plural, one {Your collaborator <strong>{firstName}</strong> needs access to <strong>Jira</strong> to view an issue you added.} other {# of your collaborators need access to <strong>Jira</strong> to view an issue you added.}}',
		description: 'Description of a flag pop up where the user can invite one or more users.',
	},
	descriptionWithPageTitleGeneric: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic',
		defaultMessage:
			'{inviteeCount, plural, one {Your collaborator <strong>{firstName}</strong> needs access to <strong>Jira</strong> to view <strong>{title}</strong>.} other {# of your collaborators need access to <strong>Jira</strong> to view <strong>{title}</strong>.}}',
		description: 'Description of a flag pop up where the user can invite one or more users.',
	},
	descriptionWithoutPageTitleGenericIssueTermRefresh: {
		id: 'invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic-issue-term-refresh',
		defaultMessage:
			'{inviteeCount, plural, one {Your collaborator <strong>{firstName}</strong> needs access to <strong>Jira</strong> to view a work item you added.} other {# of your collaborators need access to <strong>Jira</strong> to view a work item you added.}}',
		description: 'Description of a flag pop up where the user can invite one or more users.',
	},
});
